module.exports = __webpack_public_path__ + "static/media/Search Sanctions Entity ID.5cf63f12.xlsx";